export enum VoiceRequestType {
  ASK_QUESTION = "ask_question",
  CONNECT_WITH = "connect_with",
  GENERAL_QUESTION = "general_question",
}

export enum VoiceRequestStatus {
  NEW = "new",
  IN_PROGRESS = "in_progress",
  SOLVED = "solved",
}

export interface VoiceRequestItem {
  id: string;
  storyToken: string;
  accountId: string;
  accountName: string;
  storyTypeName: string;
  profileId: string | null;
  profileName: string | null;
  type: VoiceRequestType;
  topic: string | null;
  subject: string | null;
  senderFirstName: string | null;
  senderLastName: string | null;
  senderEmail: string;
  message: string | null;
  status: VoiceRequestStatus;
  createdAt: string;
  updatedAt: string;
}

export interface VoiceRequestsResponse {
  data: VoiceRequestItem[];
  meta: {
    code: number;
  };
}
